import React from "react";
import { Grid, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageTile from "../../TenantSettingsPage/ImageTile"; // adjust

export default function TenantImagesSection({
  tenantId,
  preview,
  saving,
  onPick,
  onRemoveLogo,
  onRemoveBg,
}) {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {t("tenantImagesSection.idLabel", "ID")}: {tenantId}
      </Typography>

      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={4}>
          <ImageTile
            label={t("tenantImagesSection.logo.label", "Logo")}
            name="logo_file"
            src={preview.logo}
            onPick={onPick}
            onRemove={onRemoveLogo}
            ratio="1 / 1"
            hint={t("tenantImagesSection.logo.hint", "Odporúčaný formát: PNG/SVG, štvorcové logo.")}
            objectFit="contain"
            disabled={saving}
            size="sm"
          />
        </Grid>

        <Grid item xs={12} sm={8}>
          <ImageTile
            label={t("tenantImagesSection.loginBackground.label", "Pozadie prihlásenia")}
            name="login_photo_file"
            src={preview.bg}
            onPick={onPick}
            onRemove={onRemoveBg}
            ratio="16 / 9"
            hint={t("tenantImagesSection.loginBackground.hint", "Odporúčaný formát: JPG/PNG, pomer 16:9.")}
            objectFit="cover"
            disabled={saving}
            size="md"
          />
        </Grid>
      </Grid>

      <Divider sx={{ mb: 2 }} />
    </>
  );
}
